import { ConfigurableQuestionnaireKey, QuestionType } from "@teamprevent/common/questionnaires/questionnaireConfig/models";

export interface AdditionalQuestionCreateModel {
    customerId: string;
    questionnaireType: ConfigurableQuestionnaireKey;
    questionText: string;
    questionType: QuestionType;
    options?: string[];
    isMandatory: boolean;
}

export enum MandatoryDobOrEmployeeIdEnum {
    DobRequired = "DobRequired",
    EmployeeUniqueIdRequired = "EmployeeUniqueIdRequired",
    BothRequired = "BothRequired"
}

export const mandatoryDobOrEmployeeIdOptions = [{
    text: "Dob Required",
    value: MandatoryDobOrEmployeeIdEnum.DobRequired
},{
    text: "Employee Unique Id Required",
    value: MandatoryDobOrEmployeeIdEnum.EmployeeUniqueIdRequired
},
{
    text: "Both Required",
    value: MandatoryDobOrEmployeeIdEnum.BothRequired
}];
